import { ConfigurationOntologyForAutomaticValuableConceptResponse } from '@/modules/configurationModule/detail/automation/valuable-concepts/services/configuration-valuable-concepts.dto'
import { Nullable } from '@/shared/types/app.types'
import { uniqueId } from 'lodash'

export enum LocalAutomationValuableConceptsModalTabIndex {
    FORM_DATA = 0,
    SAMPLE_TYPES = 1
}

export interface LocalAutomationValuableConceptsModalState {
    activeTab: LocalAutomationValuableConceptsModalTabIndex
    modalUID: string
    selectedRow: Nullable<ConfigurationOntologyForAutomaticValuableConceptResponse>
}
export const initialLocalAutomationValuableConceptsModalState =
    (): LocalAutomationValuableConceptsModalState => ({
        activeTab: LocalAutomationValuableConceptsModalTabIndex.FORM_DATA,
        modalUID: uniqueId(),
        selectedRow: null
    })
